"use client";
import React from "react";
import { useD3 } from "./../../src/hooks/useD3.js";
import { fv } from "./../../utils/personal-finance.js";
import * as d3 from "d3";

const years = [...Array(7).keys()].map((k) => (k + 1) * 5);
const percReturns = [...Array(25).keys()].map((k) => k + 1).reverse();
const rowHeight = 23;
const height = rowHeight * percReturns.length;
const width = 500;
const flatten = (arr) => [].concat.apply([], arr);

const yearsPerPerc = flatten(
  percReturns.map((perc) =>
    years.map((year) => ({
      perc,
      year,
      fv: fv({ rate: perc / 100.0, period: year }),
    })),
  ),
);

function OnePercTable() {
  const ref = useD3(
    (svg) => {
      const margin = { top: 20, right: 20, bottom: 30, left: 45 };

      // console.log(yearsPerPerc);
      // only for dev
      svg.select(".plot-area").selectAll("g").remove();

      const x = d3
        .scaleBand()
        .domain(yearsPerPerc.map((d) => d.year))
        .rangeRound([margin.left, width - margin.right])
        .padding(0.1);
      const y = d3
        .scaleBand()
        .domain(yearsPerPerc.map((d) => d.perc))
        .rangeRound([margin.top, height - margin.bottom])
        .padding(0.1);

      const fvs = yearsPerPerc.map((d) => d.fv);
      const color = d3
        .scaleLog()
        .domain([d3.min(fvs), d3.max(fvs)])
        .range(["#fffaf3", "orange"]);
      // .interpolate(d3.interpolateGreens);

      const rect = svg
        .select(".plot-area")
        // .attr("fill", "steelblue")
        .selectAll(".rect")
        .data(yearsPerPerc)
        .join("g");

      rect
        .append("rect")
        .attr("x", (d) => x(d.year))
        .attr("width", x.bandwidth())
        .attr("y", (d) => y(d.perc))
        .attr("rx", 2)
        .attr("height", (d) => y.bandwidth())
        .style("fill", (d) => color(d.fv));

      rect
        .append("text")
        .attr("x", (d) => x(d.year) + x.bandwidth() - 5)
        .attr("text-anchor", "end")
        .attr("y", (d) => y(d.perc) + 14)
        .style("fill", "#222")
        .style("font", "normal 12px mono")
        .text((d) => d3.format(" >,.2s")(d.fv));

      rect
        .append("title")
        .text(
          (d) =>
            `In ${d.year} years, at ${
              d.perc
            } percentage interest, your money would be ${d.fv.toFixed(
              2,
            )} times it's initial value.`,
        );

      const xAxis = (g) =>
        g
          .attr("transform", `translate(0, ${height - margin.bottom})`)
          .style("color", "var(--nord3-5)")
          .call(d3.axisBottom(x).tickValues(years).tickPadding(10));

      const yAxis = (g) =>
        g
          .attr("transform", `translate(${margin.left}, 0)`)
          .style("color", "var(--nord3-5)")
          .call(
            d3
              .axisLeft(y)
              .tickValues(percReturns)
              .tickFormat((d) => d3.format(".0%")(d / 100)),
          );

      svg.select(".x-axis").call(xAxis);
      svg.select(".y-axis").call(yAxis);
    },
    [yearsPerPerc.length],
  );

  return (
    <svg
      ref={ref}
      viewBox={`0 0 ${width} ${rowHeight * percReturns.length}`}
      style={{
        width: "100%",
        marginRight: "0px",
        marginLeft: "0px",
      }}
    >
      <g className="plot-area" />
      <g className="x-axis" />
      <g className="y-axis" />
      <g className="tooltip-area">
        <text className="tooltip-area__text"></text>
      </g>
    </svg>
  );
}

export default OnePercTable;
